// extracted by mini-css-extract-plugin
module.exports = {"wine":"wine-1NhP27XV"};